import {
  Clock,
  LayoutGrid,
  Sparkles,
  UserRound,
  type LucideIcon,
} from "lucide-react";

export type ActionTab = "profile" | "context" | "tools" | "history";

export const DEFAULT_ACTION_TAB: ActionTab = "context";

export interface ActionTabConfig {
  id: ActionTab;
  label: string;
  icon: LucideIcon;
}

export const ACTION_TABS: readonly ActionTabConfig[] = [
  { id: "context", label: "Context", icon: Sparkles },
  { id: "profile", label: "Profile", icon: UserRound },
  { id: "tools", label: "Tools", icon: LayoutGrid },
  { id: "history", label: "History", icon: Clock },
];

export function isActionTab(value: unknown): value is ActionTab {
  return ACTION_TABS.some((tab) => tab.id === value);
}
